import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  notifications: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the notifications
export const fetchNotifications = createAsyncThunk(
  "fetchNotifications/notifications",
  async ({ enqueueSnackbar, limit = 100, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`admin/notifications`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: response.data.data.meta,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create notification
export const createNotification = createAsyncThunk(
  "createNotification/notifications",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`admin/notifications`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  extraReducers: (builder) => {
    // Fetch notifications
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.fetchLoading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.fetchLoading = false;
        if (action.payload) {
          action.payload.enqueueSnackbar(
            action.payload.error?.message || "Error fetching notifications",
            {
              variant: "error",
            }
          );
        }
      });

    // Create notification
    builder
      .addCase(createNotification.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications.data = [
          action.payload.data,
          ...state.notifications.data,
        ];
        state.notifications.meta.total = state.notifications.meta.total + 1
        action.payload.enqueueSnackbar("Notification created successfully", {
          variant: "success",
        });
        action.payload.handleClose();
      })
      .addCase(createNotification.rejected, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          action.payload.enqueueSnackbar(
            action.payload.error?.message || "Error creating notification",
            {
              variant: "error",
            }
          );
        }
      });
  },
});

export default notificationSlice.reducer;
